import React from "react";

import useMenu from "../../../hooks/useMenu";

import HeaderMenuList from "./HeaderMenuList";
import HeaderMenuItem from "./HeaderMenuItem";
import HeaderSubMenu from "./HeaderSubMenu";

const Menu = () => {
    const menuHeader = useMenu();

    return (
        <HeaderMenuList>
            {
                menuHeader.map(({ subMenu, name, permission, ...retProps }, i) => {
                    if(subMenu) {
                        return (
                            <HeaderSubMenu
                                key={i}
                                name={name}
                                permission={permission}
                                subMenu={subMenu}
                            />
                        );
                    }

                    return (
                        <HeaderMenuItem
                            key={i}
                            name={name}
                            permission={permission}
                            {...retProps}
                        />
                    );
                })
            }
        </HeaderMenuList>
    );
};

export default Menu;
